import React from 'react';

//Estilos base:
let mainCardStyle = {
    paddingTop: 20
};

export const processesRegistryTourConfig = [
    {
        selector: '',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta es la consola <b>de histórico de descargas</b>. También le llaman reportes.</p>
                <p>Aquí podrás visualizar el <b>histórico</b> de descargas; el <b>resultado</b> de los procesos
                y <b>descargar</b> los archivos generados.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.sourcesFilterManager"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con esta herramienta, puedes controlar el histórico <b>de qué fuentes</b> de descarga quieres ver.</p>
                <p>Cada vez que selecciones o elimines una fuente, el módulo de la derecha se <b>actualizará</b> automáticamente.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.statusFilterManager"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Asimismo, aquí puedes controlar las descargas que quieres ver según su <b>estado</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__mainLayout.filterManagerQuickButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Este botón de acceso rápido te permitirá seleccionar <b>todas o ninguna</b> fuente, según corresponda, con un click.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.processesRegistryTable"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta tabla contiene el registro histórico de descargas de las fuentes <b>seleccionadas</b> con la herramienta de filtrado.</p>
                <p>Puedes <b>ordenar</b> la búsqueda haciendo click sobre cualquiera de los encabezados de las columnas.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.processesRegistryTableRowDescription"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Cada fila en la tabla <b>equivale</b> a un proceso de descarga ejecutado en algún momento del pasado.</p>
                <p>La información desplegada corresponde a la de dicho proceso.
                    Puedes acceder al <b>detalle</b> haciendo click en el icono de resultado.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.processesRegistryTableFileButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Si el proceso terminó con <b>éxito</b>, este botón estará habilitado.
                Haciendo click en él, podrás <b>descargar</b> de forma rápida los <b>ficheros generados</b>.</p>
                <p>Este botón requiere permisos...</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.processesRegistryTablePagination"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con este conjunto de botones puedes <b>extender o reducir</b> el tamaño de tu búsqueda.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__processesRegistry.processesRegistryTablePaginationResume"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Puedes consultar la <b>cantidad</b> de registros mostrados aquí.</p>
            </div>
        )
    },

];